import { Component, Input, OnInit } from '@angular/core';

export enum StatisticsItemType {
  number = 'number',
  money = 'money',
  percent = 'percent',
  date = 'date'
}
@Component({
  selector: 'app-dynamic-number-view',
  templateUrl: './dynamic-number-view.component.html',
  styleUrls: ['./dynamic-number-view.component.css']
})
export class DynamicNumberViewComponent implements OnInit {
  @Input() value: number | string;
  @Input() title: string;
  @Input() type: StatisticsItemType = StatisticsItemType.number
  constructor() { }

  ngOnInit() {
  }

}
